import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import { assertNever } from "@protobuf-ts/runtime";
/**
 * Creates a "stack" of of all interceptors specified in the given `RpcOptions`.
 * Used by generated client implementations.
 * @internal
 */

export function stackIntercept(kind, transport, method, options, input) {
  var _a, _b, _c, _d;

  if (kind == "unary") {
    var tail = function tail(mtd, inp, opt) {
      return transport.unary(mtd, inp, opt);
    };

    var _iterator = _createForOfIteratorHelper(((_a = options.interceptors) !== null && _a !== void 0 ? _a : []).filter(function (i) {
      return i.interceptUnary;
    }).reverse()),
        _step;

    try {
      var _loop = function _loop() {
        var curr = _step.value;
        var next = tail;

        tail = function tail(mtd, inp, opt) {
          return curr.interceptUnary(next, mtd, inp, opt);
        };
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return tail(method, input, options);
  }

  if (kind == "serverStreaming") {
    var _tail = function _tail(mtd, inp, opt) {
      return transport.serverStreaming(mtd, inp, opt);
    };

    var _iterator2 = _createForOfIteratorHelper(((_b = options.interceptors) !== null && _b !== void 0 ? _b : []).filter(function (i) {
      return i.interceptServerStreaming;
    }).reverse()),
        _step2;

    try {
      var _loop2 = function _loop2() {
        var curr = _step2.value;
        var next = _tail;

        _tail = function _tail(mtd, inp, opt) {
          return curr.interceptServerStreaming(next, mtd, inp, opt);
        };
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return _tail(method, input, options);
  }

  if (kind == "clientStreaming") {
    var _tail2 = function _tail2(mtd, opt) {
      return transport.clientStreaming(mtd, opt);
    };

    var _iterator3 = _createForOfIteratorHelper(((_c = options.interceptors) !== null && _c !== void 0 ? _c : []).filter(function (i) {
      return i.interceptClientStreaming;
    }).reverse()),
        _step3;

    try {
      var _loop3 = function _loop3() {
        var curr = _step3.value;
        var next = _tail2;

        _tail2 = function _tail2(mtd, opt) {
          return curr.interceptClientStreaming(next, mtd, opt);
        };
      };

      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return _tail2(method, options);
  }

  if (kind == "duplex") {
    var _tail3 = function _tail3(mtd, opt) {
      return transport.duplex(mtd, opt);
    };

    var _iterator4 = _createForOfIteratorHelper(((_d = options.interceptors) !== null && _d !== void 0 ? _d : []).filter(function (i) {
      return i.interceptDuplex;
    }).reverse()),
        _step4;

    try {
      var _loop4 = function _loop4() {
        var curr = _step4.value;
        var next = _tail3;

        _tail3 = function _tail3(mtd, opt) {
          return curr.interceptDuplex(next, mtd, opt);
        };
      };

      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop4();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return _tail3(method, options);
  }

  assertNever(kind);
}
/**
 * @deprecated replaced by `stackIntercept()`, still here to support older generated code
 */

export function stackUnaryInterceptors(transport, method, input, options) {
  return stackIntercept("unary", transport, method, options, input);
}
/**
 * @deprecated replaced by `stackIntercept()`, still here to support older generated code
 */

export function stackServerStreamingInterceptors(transport, method, input, options) {
  return stackIntercept("serverStreaming", transport, method, options, input);
}
/**
 * @deprecated replaced by `stackIntercept()`, still here to support older generated code
 */

export function stackClientStreamingInterceptors(transport, method, options) {
  return stackIntercept("clientStreaming", transport, method, options);
}
/**
 * @deprecated replaced by `stackIntercept()`, still here to support older generated code
 */

export function stackDuplexStreamingInterceptors(transport, method, options) {
  return stackIntercept("duplex", transport, method, options);
}